import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import styles from "./SessionCard.module.css";
import useDashboardStore from "../../store/dashboardStore";
import { FaForward } from "react-icons/fa";
import { useState } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);

function getFormattedSessionDate(start_datetime) {
  return dayjs.utc(start_datetime).local().format("DD MMM YYYY");
}

function getFormattedSessionTime(start_datetime, end_datetime) {
  const start = dayjs.utc(start_datetime).local();
  const end = dayjs.utc(end_datetime).local();
  return `${start.format("hh:mm A")} - ${end.format("hh:mm A")}`;
}

function getSessionDurationInMinutes(start_datetime, end_datetime) {
  const start = dayjs.utc(start_datetime).local();
  const end = dayjs.utc(end_datetime).local();
  const durationInMinutes = end.diff(start, "minute");
  return `${durationInMinutes}`;
}

const SessionCard = ({ session }) => {
  const { setIsZoomMeetingScreen, setSelectedZoomSession, users } =
    useDashboardStore();
  const traderName =
    users.find((e) => e.id === session.instructor_id)?.display_name || "...";
  const [showPopup, setShowPopup] = useState(false);

  const handleJoinSession = () => {
    const now = dayjs();
    const sessionStart = dayjs.utc(session.start_datetime).local();

    if (now.isBefore(sessionStart)) {
      // Session hasn't started yet
      setShowPopup(true);
    } else {
      // Session has started
      setIsZoomMeetingScreen();
      setSelectedZoomSession(session);
    }
  };

  return (
    <>
      <div className={styles.sessionCard} onClick={handleJoinSession}>
        <div className={styles.iconSection}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="none"
            viewBox="0 0 24 24"
            stroke="#158CA5"
            strokeWidth="1.5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z"
            />
          </svg>
        </div>

        <div className={styles.timeSection}>
          <div className={styles.date}>
            {getFormattedSessionDate(session.start_datetime)}
          </div>
          <div className={styles.hours}>
            {getFormattedSessionTime(
              session.start_datetime,
              session.end_datetime,
            )}
          </div>
        </div>

        <div className={styles.infoSection}>
          <div className={styles.title}>{session.session_title}</div>
          <div className={styles.instructor}>
            Instructor: <span>{traderName}</span>
          </div>
        </div>

        <div className={styles.durationSection}>
          <div className={styles.minutes}>
            {getSessionDurationInMinutes(
              session.start_datetime,
              session.end_datetime,
            )}
          </div>
          <div className={styles.label}>Minutes</div>
        </div>

        <div className={styles.durationSection}>
          <div className={styles.arrow}>
            <FaForward />
          </div>
        </div>
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div
          className={styles.popupOverlay}
          onClick={() => setShowPopup(false)}
        >
          <div
            className={styles.popupContent}
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Session Not Started Yet</h3>
            <p>
              This session hasn't started yet. Please wait until the scheduled
              time.
            </p>
            <button
              className={styles.popupButton}
              onClick={() => setShowPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SessionCard;
